import {
  Filter,
  SmartViewWidget,
  CategoryGroup,
  ViewType,
} from '@nirvana/shared/dtos/types/generic-dashboards/gz-console';

export interface DashboardSmartViewBase {
  label: string;
  editable: boolean;
  active: boolean;
  categoryGroup: CategoryGroup;
  type: ViewType;
  filters: Array<Filter>;
  widgets: Array<SmartViewWidget>;
  decoratedTextOnSearch?: string;
}

export interface DashboardSmartView extends DashboardSmartViewBase {
  id: string;
}

export enum SmartViewInlineActions {
  RENAME = 'rename',
  DELETE = 'delete',
}

export enum SmartViewEvents {
  SMART_VIEW_SELECTED = 'smartViewSelected',
}

export interface SmartViewRenameConfig {
  smartViewId: string;
  newName: string;
}
